import { type MenuExtras, group } from '@burfy/docs-editor/ui';

/**
 * The menu groups the *app* owns.
 *
 * The editor's own menus act on text; these act on the document and on the
 * window around it — opening another one, downloading this one, changing the
 * paper it is laid out for. Built here as data so the route stays a component
 * and this stays testable.
 */

export interface DocumentMenuActions {
  onNewDocument: () => void;
  onAllDocuments: () => void;
  onExport: () => void;
  onPageSetup: () => void;
  onZoomChange: (zoom: number) => void;
  onToggleRuler: () => void;
  onToggleOutline: () => void;
}

export interface DocumentMenuState {
  zoom: number;
  zoomLevels: readonly number[];
  showRuler: boolean;
  showOutline: boolean;
}

export function createDocumentMenus(
  state: DocumentMenuState,
  actions: DocumentMenuActions,
): MenuExtras {
  return {
    file: [
      group('documents', [
        { id: 'new', label: 'New document', run: actions.onNewDocument },
        { id: 'all', label: 'All documents', run: actions.onAllDocuments },
      ]),
      group('transfer', [
        { id: 'export', label: 'Download…', run: actions.onExport },
        { id: 'page-setup', label: 'Page setup…', run: actions.onPageSetup },
      ]),
    ],

    view: [
      group(
        'zoom',
        state.zoomLevels.map((level) => ({
          id: `zoom-${level}`,
          label: `${Math.round(level * 100)}%`,
          checked: state.zoom === level,
          run: () => actions.onZoomChange(level),
        })),
      ),
      group('panels', [
        {
          id: 'ruler',
          label: 'Show ruler',
          checked: state.showRuler,
          run: actions.onToggleRuler,
        },
        {
          id: 'outline',
          label: 'Show outline',
          checked: state.showOutline,
          run: actions.onToggleOutline,
        },
      ]),
    ],
  };
}
